export function getIntroAlertObject(keyIntro1, keyIntro2) {
  const intro1 = edicom.locale.translate(keyIntro1);
  const intro2 = keyIntro2 ? `<br/><br/>${edicom.locale.translate(keyIntro2)}` : '';

  return {
    type: 'object',
    name: 'textContent.html',
    cols: 4,
    properties: [
      {
        name: 'introAlert',
        type: 'alert',
        metadata: {
          closable: false,
          style: 'flat',
          content: `<div style="white-space:normal">${intro1}${intro2}</div>`,
        },
        cols: 8,
      },
    ],
  };
}
